/* Native homepage interactions. Safe to include for each independently added section. */
(() => {
  if (window.FPBHome) return;
  const carouselStates = new WeakMap();
  const textFromMoney = (value) => {
    const template = document.createElement('template');
    template.innerHTML = value || '';
    return template.content.textContent || '';
  };
  function syncProduct(card) {
    const select = card.querySelector('[data-fpb-variant]');
    const option = select?.selectedOptions[0];
    if (!option) return;
    card.querySelector('[data-fpb-price]').textContent = textFromMoney(option.dataset.price);
    const compare = card.querySelector('[data-fpb-compare]');
    compare.textContent = textFromMoney(option.dataset.compare);
    compare.hidden = !option.dataset.compare;
    const button = card.querySelector('[data-fpb-add]');
    const available = option.dataset.available === 'true';
    button.disabled = !available;
    button.textContent = available ? 'Add To Cart' : 'Sold out';
    const image = card.querySelector('img.fpb-product-image');
    if (image && option.dataset.image && image.getAttribute('src') !== option.dataset.image) {
      image.removeAttribute('srcset');
      image.src = option.dataset.image;
      image.alt = option.dataset.imageAlt || '';
    }
  }
  function initCarousel(carousel) {
    if (carouselStates.has(carousel)) return;
    const track = carousel.querySelector('.fpb-slider');
    const previous = carousel.querySelector('.fpb-slider-prev');
    const next = carousel.querySelector('.fpb-slider-next');
    if (!track || !previous || !next) return;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    function update() {
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      const position = Math.abs(track.scrollLeft);
      previous.disabled = position <= 2;
      next.disabled = position >= max - 2;
      previous.hidden = next.hidden = max <= 2;
    }
    function move(direction) {
      const slide = track.querySelector('.fpb-slide');
      const width = slide?.getBoundingClientRect().width || track.clientWidth;
      const rtl = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
      track.scrollBy({ left: direction * width * rtl, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    previous.addEventListener('click', () => move(-1), options);
    next.addEventListener('click', () => move(1), options);
    track.addEventListener('scroll', update, { ...options, passive: true });
    const observer = new ResizeObserver(update);
    observer.observe(track);
    carouselStates.set(carousel, { observer, controller });
    update();
  }
  function init(root = document) {
    root.querySelectorAll('[data-fpb-carousel]').forEach(initCarousel);
  }
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-fpb-variant]')) syncProduct(event.target.closest('[data-fpb-product-card]'));
  });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-fpb-carousel]').forEach((carousel) => {
      const state = carouselStates.get(carousel);
      state?.observer.disconnect();
      state?.controller.abort();
      carouselStates.delete(carousel);
    });
  });
  window.FPBHome = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();